import { useStore, useRouter } from '@/utils/vue-api';

/**
 * 地区选择器 Composable（纯函数集合）
 * 不管理任何内部状态，所有方法通过参数接收 scopeKey
 */
export function useRegionSelector() {
	const store = useStore();
	const router = useRouter();

	/**
	 * 构建 scopeKey
	 * @param {...(string|number)} args - 多个参数，用下划线连接
	 * @returns {string} scopeKey
	 * @example
	 * buildScopeKey('appointment_form') // 'appointment_form'
	 * buildScopeKey('entourage', 0) // 'entourage_0'
	 */
	function buildScopeKey(...args) {
		return args.filter(arg => arg != null && arg !== '').join('_');
	}

	/**
	 * 获取指定 scopeKey 对应的地区选择
	 * @param {string} scopeKey - 作用域标识
	 * @returns {Object|null} 地区选择对象 { key, value, index } 或 null
	 */
	function getRegion(scopeKey) {
		return store.getters['regionSelector/getRegion'](scopeKey);
	}

	/**
	 * 打开地区选择页面
	 * @param {string} scopeKey - 作用域标识
	 * @param {Object} restQuery - 其他查询参数
	 */
	function openRegionSelector(scopeKey, restQuery = {}) {
		router.push({
			name: 'areaCode_index',
			query: {
				scopeKey,
				...restQuery
			}
		});
	}

	/**
	 * 清除指定 scopeKey 的地区选择
	 * @param {string} scopeKey - 作用域标识
	 */
	function clearRegion(scopeKey) {
		store.dispatch('regionSelector/clearRegion', scopeKey);
	}

	return {
		buildScopeKey,
		getRegion,
		openRegionSelector,
		clearRegion
	};
}
